<template>
        <v-card class="elevation-10">
            <v-card-title>
                Sample Orders
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="samples.data"
                    :search="search"
                    :pagination.sync="pagination"
                    hide-actions
                    :loading="loading"
                    :total-items="8"
            >
                <template slot="items" slot-scope="props">
                    <td><v-btn flat small>{{ props.item.request_ }}</v-btn></td>
                    <td class="text-xs">{{ props.item.status_name}}</td>
                    <td class="text-xs">{{ props.item.track_number }}</td>
                    <td class="text-xs">{{ props.item.date }}</td>
                    <td class="layout px-0">
                        <v-speed-dial
                                v-model="fab[props.index]"
                                :top="top"
                                :bottom="bottom"
                                :right="right"
                                :left="left"
                                :direction="direction"
                                :open-on-hover="hover"
                                :transition="transition"
                        >
                            <v-btn
                                    slot="activator"
                                    v-model="fab[props.index]"
                                    color="primary"
                                    dark
                                    fab
                                    flat
                            >
                                <v-icon>settings</v-icon>
                                <v-icon>close</v-icon>
                            </v-btn>
                            <v-btn
                                    fab
                                    dark
                                    small
                                    color="secondary"
                            >
                                <v-icon color="primary">remove_red_eye</v-icon>
                            </v-btn>
                        </v-speed-dial>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
            <div class="text-xs-center pt-4 pb-4" v-if="samples.data">
                <v-pagination
                        v-model="page"
                        :length="last_page"
                        color="secondary"
                        circle
                        :total-visible="7"
                        @input="setPage"
                ></v-pagination>
            </div>
        </v-card>
</template>

<script>
    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: false,
                headers: [
                    {
                        text: 'Sample request',
                        align: 'left',
                        sortable: false,
                        value: 'concept'
                    },
                    { text: 'Status', value: 'status', sortable: false },
                    { text: 'Tracking number', value: 'tracking', sortable: false },
                    { text: 'Date', value: 'date', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                samples: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition'
            }
        },
        created: function() {
            this.getSamples();
            this.debouncedGetSamples = _.debounce(this.getSamples, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetSamples();
            },
            last_page: function () {
                if (this.page > this.samples.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            setPage (page) {
                this.page = page;
                this.getOrders();
            },
            getSamples () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page
                    }
                };
                this.$store.dispatch('getSamples', params).then((res) => {

                    this.samples = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/client/samples/ListComponent.vue